export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 25% 50%, oklch(var(--primary-500) / 0.3) 0%, transparent 50%), radial-gradient(circle at 75% 50%, oklch(var(--accent-500) / 0.2) 0%, transparent 50%)',
        }}
      />

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs md:text-sm font-medium mb-4 md:mb-6">
              <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center"></i>
              <span>2026暑期档热映中</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3 md:mb-4">
              91影视看片下载
              <span className="block text-primary-600 text-xl md:text-3xl lg:text-4xl mt-1">
                高清影视在线播放平台
              </span>
            </h1>

            <p className="text-base md:text-lg font-heading text-foreground-500 mb-4 md:mb-6 italic">
              即点即播 · 流畅不缓冲 · 每日更新
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-8">
              91影视看片下载是国内领先的在线影视视频播放平台，提供麻豆影视在线观看、热门电影电视剧高清全集免费在线播放。
              覆盖华语大片、韩影高分、日剧经典、好莱坞巨制、动漫番剧等全品类内容。
              院线热门下映后48小时内极速上线，即点即播无需下载，流畅不缓冲。
              本期暑期档专题已上线《消失的她2》《长安十二时辰2》等热播内容，每日片库持续扩充中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-600 text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm md:text-base font-bold text-foreground-900">5,000+</div>
                  <div className="text-xs text-foreground-500">累计片库</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-user-smile-line text-primary-600 text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm md:text-base font-bold text-foreground-900">800万+</div>
                  <div className="text-xs text-foreground-500">注册用户</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-secondary-200 flex items-center justify-center">
                  <i className="ri-flashlight-line text-secondary-600 text-sm md:text-base w-4 h-4 flex items-center justify-center"></i>
                </div>
                <div className="text-left">
                  <div className="text-sm md:text-base font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">片库同步</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm md:text-base font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill w-5 h-5 flex items-center justify-center"></i>
                立即观影
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm md:text-base font-medium rounded-full border-2 border-secondary-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line w-5 h-5 flex items-center justify-center"></i>
                探索专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20dramatic%20warm%20golden%20and%20crimson%20lighting%2C%20movie%20projector%20beam%20cutting%20through%20darkness%2C%20film%20reel%20textures%2C%20professional%20cinema%20aesthetic%2C%20abstract%20artistic%20composition%2C%20clean%20dark%20background&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="91影视看片下载 - 高清影视在线播放"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}